// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"6614c078","570":"bc6353aa","675":"5413e108","709":"30764242","912":"756a1504"}[chunkId] + ".chunk.css";
};